/**
 * Axios-based HTTP client for communicating with the BFF API.
 * All requests include credentials (cookies) so the session cookie
 * is sent automatically.
 *
 * @module procedural/apiClient
 */

import axios  from 'axios';
import config from '../config';

/**
 * Pre-configured axios instance pointing at the BFF API.
 */
const apiClient = axios.create({
  baseURL: config.api.baseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
